import { CommonModule, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { KENDO_BUTTON, KENDO_BUTTONGROUP } from '@progress/kendo-angular-buttons';
import { TypesServices } from '../../../@theme/services/typeslist.service';
import { RepEditorStateService } from '../shared/rep-editor-state.service';
import { TypeEditorAssistantTypeComponent } from './type-editor-assistant-type/type-editor-assistant-type.component';
import { TypeEditorBankComponent } from './type-editor-bank/type-editor-bank.component';
import { TypeEditorBranchComponent } from './type-editor-branch/type-editor-branch.component';
import { TypeEditorBrokerFirmComponent } from './type-editor-broker-firm/type-editor-broker-firm.component';
import { TypeEditorCrdBranchTypeComponent } from './type-editor-crd-branch-type/type-editor-crd-branch-type.component';
import { TypeEditorCrdBranchComponent } from './type-editor-crd-branch/type-editor-crd-branch.component';
import { TypeEditorFirmTypeComponent } from './type-editor-firm-type/type-editor-firm-type.component';
import { TypeEditorLicenseTypeComponent } from './type-editor-license-type/type-editor-license-type.component';
import { TypeEditorNoteTypeComponent } from './type-editor-note-type/type-editor-note-type.component';
import { TypeEditorOfficeTypeComponent } from './type-editor-office-type/type-editor-office-type.component';
import { TypeEditorProTypeComponent } from './type-editor-pro-type/type-editor-pro-type.component';
import { TypeEditorRegionComponent } from './type-editor-region/type-editor-region.component';
import { TypeEditorSocialMediaComponent } from './type-editor-social-media/type-editor-social-media.component';
import { TypeEditorStatesComponent } from './type-editor-states/type-editor-states.component';
import { TypeEditorSubscriptionComponent } from './type-editor-subscription/type-editor-subscription.component';
import { TypeEditorTypeOfFirmComponent } from './type-editor-type-of-firm/type-editor-type-of-firm.component';

export enum TypeSectionEnum {
  ApprovedSocialMedia,
  AssistantType,
  Bank,
  Branch,
  BrokerFirm,
  CrdBranch,
  CrdBranchType,
  Firm,
  FirmType,
  License,
  NoteType,
  OfficeType,
  ProType,
  Region,
  StateFee,
  Subscription,
}

@Component({
  selector: 'gd-type-editor',
  templateUrl: './type-editor.component.html',
  styleUrls: ['./type-editor.component.scss'],
  imports: [
    CommonModule,
    KENDO_BUTTON,
    KENDO_BUTTONGROUP,
    NgSwitch,
    NgSwitchCase,
    TypeEditorSocialMediaComponent,
    TypeEditorAssistantTypeComponent,
    TypeEditorBankComponent,
    TypeEditorBranchComponent,
    TypeEditorBrokerFirmComponent,
    TypeEditorCrdBranchComponent,
    TypeEditorCrdBranchTypeComponent,
    TypeEditorFirmTypeComponent,
    TypeEditorTypeOfFirmComponent,
    TypeEditorLicenseTypeComponent,
    TypeEditorNoteTypeComponent,
    TypeEditorOfficeTypeComponent,
    TypeEditorProTypeComponent,
    TypeEditorRegionComponent,
    TypeEditorStatesComponent,
    TypeEditorSubscriptionComponent,
  ]
})
export class TypeEditorComponent implements OnInit {
  public typeSectionEnum = TypeSectionEnum
  public currentSection: TypeSectionEnum = TypeSectionEnum.ApprovedSocialMedia

  constructor(
    private typesService: TypesServices,
    private repState: RepEditorStateService,
  ) { }

  ngOnInit() {
    this.typesService.getAssistantLookups().subscribe((response) => {
      this.repState.assistantLookups = response
    })
    this.typesService.getActiveTypeStatelist().subscribe((response) => {
      this.repState.stateList = response
    })
    this.typesService.getCompleteStatelist().subscribe((response) => {
      this.repState.stateListWithInactive = response
    })
    this.typesService.getLicenseList().subscribe((response) => {
      this.repState.licenseList = response
    })
    this.typesService.getNoteTypes().subscribe((response) => {
      this.repState.noteTypeList = response
    })
    this.typesService.getProTypes().subscribe((response) => {
      this.repState.proTypes = response
    })
    this.typesService.getFirmTypes().subscribe((response) => {
      this.repState.firmTypeList = response
    })
    this.typesService.getApprovedSocialMedia().subscribe((response) => {
      this.repState.approvedSocialMedia = response
    })
    this.typesService.getSubscription().subscribe((response) => {
      this.repState.subscriptions = response
    })
    this.typesService.getTypesOfFirms().subscribe((response) => {
      this.repState.typesOfFirms = response
    })
    this.typesService.getBank().subscribe((response) => {
      this.repState.banks = response
    })
    this.typesService.getBrokerFirm().subscribe((response) => {
      this.repState.brokerFirms = response
    })
    this.typesService.getOfficeType().subscribe((response) => {
      this.repState.officeTypes = response
    })
    this.typesService.getRegion().subscribe((response) => {
      this.repState.regions = response
    })
    this.typesService.getCRDBranchType().subscribe((response) => {
      this.repState.crdBranchTypes = response
    })
    this.typesService.getBranch().subscribe((response) => {
      this.repState.branches = response
    })
    this.typesService.getTypesOfFirms().subscribe((response) => {
      this.repState.typesOfFirms = response
    })
    this.typesService.getCRDBranch().subscribe((response) => {
      this.repState.crdBranches = response
    })
  }

  public switchSection(section: TypeSectionEnum) {
    this.currentSection = section
  }
}
